import React, { useState, useEffect } from 'react'
import api from "../api/api.passwordreset"
import { toast } from 'react-toastify';
import socketIOClient from "socket.io-client";
import baseUrl from '../config.json'
//import './style.css'
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar'
const ENDPOINT = baseUrl.apiEndPoint;

function Passwordreset(props){

    //const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')
    const [password3, setPassword3] = useState('')

    const[userid,setUserid]=useState(localStorage.userid);
    useEffect(()=>{
      if(props.match.params.id)
      {
      setUserid(props.match.params.id)
      }
    },[])

    return(<div class="wrapper">
            <SideBar />
            <div class="main-panel">
                <TopBar />
          
                <div class="content" >
        <div class="container-fluid">
          <div class="row" >
            <div class="col-lg-12 col-md-12">
              <div class="card">
                <div class="header">
                  <h5 class="title">Reset Password</h5>
                </div>
                <div class="content" style={{ 'padding': '15px' }}>

                  <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                      <form>
                        

                        <div class="form-group" >
                          <label>New Password</label>
                          <input type="password" class="form-control border-input" placeholder="Password" value={password2} onChange={(e) => {
                            setPassword2(e.target.value)
                          }}></input>
                        </div>

                         <div class="form-group" style={{'margin-top':'15px'}}>
                          <label>Confirm Password</label>
                          <input type="password" class="form-control border-input" placeholder="Password" value={password3} onChange={(e) => {
                            setPassword3(e.target.value)
                          }}></input>
                        </div>
                        


                        <div class="form-group">
                          <div style={{ 'margin': '15px 0px' }}>
                            <button class="btn btn-info btn-fill btn-wd" style={{'margin':'0px'}} onClick={(e)=>{
                              e.preventDefault()
                              if(password2==password3)
                              {
                                let data ={
                                  "password": password2
                                }
                                api.passwordreset(userid,data).then(res => {
                                toast("Password reset successfully")
                                setPassword2('')
                                setPassword3('')
                                })
                              }else{
                                toast("Password mismatch")
                              }
                            }}
                             

                            >Reset</button>



                          </div>
                        </div>

                      </form>
                    </div>
                    
                  </div>

                





                
                </div>
                </div>
              
            </div>
          
          </div>


        </div>

      </div>
    </div>
         </div> 
        
    )
}
export default Passwordreset;